(function() {
  var injected = false;
  var SCROLL_DUUR_MS = 600; // pas dit getal aan om sneller (lager) of langzamer (hoger) te scrollen

  function scrollNaarMetDuur(element, duurMs) {
    var startY = window.scrollY;
    var elementRect = element.getBoundingClientRect();
    var targetY = startY + elementRect.top - (window.innerHeight / 2) + (elementRect.height / 2);
    var startTime = null;

    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    }

    function stap(timestamp) {
      if (!startTime) startTime = timestamp;
      var verstreken = timestamp - startTime;
      var voortgang = Math.min(verstreken / duurMs, 1);
      window.scrollTo(0, startY + (targetY - startY) * easeInOutQuad(voortgang));
      if (voortgang < 1) {
        requestAnimationFrame(stap);
      }
    }
    requestAnimationFrame(stap);
  }

  function injectVideos() {
    if (injected) return;

    var videolySlider = document.querySelector('#videoly-videobox-placeholder videoly-slider');
    if (!videolySlider) return;

    var swiperWrapper = document.querySelector('ul.l4pr .swiper-wrapper');
    if (!swiperWrapper) return;

    var videoList = [];
    try {
      videoList = JSON.parse(videolySlider.getAttribute('videolist') || '[]');
    } catch(e) { return; }

    var youtubeVideos = videoList.filter(function(v) { return v.type === 'youtube'; });
    if (!youtubeVideos.length) return;

    var existingSlide = swiperWrapper.querySelector('.swiper-slide');
    var slideClass = existingSlide
      ? existingSlide.className
          .replace('swiper-slide-active','')
          .replace('swiper-slide-next','')
          .replace('swiper-slide-prev','')
          .trim()
      : 'swiper-slide';

    var createdSlides = [];

    // --- 1. Video-slides toevoegen aan de hoofdgallerij (achteraan) ---
    youtubeVideos.forEach(function(video, index) {
      var thumbHigh = (video.thumbs && video.thumbs.high && video.thumbs.high.url)
        ? video.thumbs.high.url
        : 'https://img.youtube.com/vi/' + video.providerVideoId + '/hqdefault.jpg';

      var slide = document.createElement('div');
      slide.className = slideClass + ' has-video-slide';
      slide.style.cursor = 'pointer';

      slide.innerHTML =
        '<li class="has-anchor li" role="none" style="position:relative;">' +
          '<picture class="">' +
            '<img src="' + thumbHigh + '"' +
            ' alt="' + (video.title || 'Video') + '"' +
            ' width="430" height="430"' +
            ' loading="eager"' +
            ' style="object-position:unset;width:100%;display:block;">' +
          '</picture>' +
          '<span style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:52px;height:52px;background:rgba(0,0,0,0.65);border-radius:50%;display:flex;align-items:center;justify-content:center;pointer-events:none;z-index:2;">' +
            '<svg viewBox="0 0 24 24" fill="white" width="26" height="26"><polygon points="5,3 19,12 5,21"/></svg>' +
          '</span>' +
        '</li>';

      slide.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var details = document.querySelector('.faq-videoly-tab');
        if (details && !details.open) {
          details.open = true;
        }

        var placeholder = document.querySelector('#videoly-videobox-placeholder');
        if (placeholder) {
          scrollNaarMetDuur(placeholder, SCROLL_DUUR_MS);
        }

        setTimeout(function() {
          var vs = document.querySelector('videoly-slider');
          if (vs && vs.tileElements && vs.tileElements[index]) {
            vs.tileElements[index].click();
          }
        }, 600);
      });

      swiperWrapper.appendChild(slide);
      createdSlides.push(slide);
    });

    // --- 2. Swiper update veilig ---
    var swiperEl = document.querySelector('ul.l4pr .swiper-outer');
    if (swiperEl && swiperEl.swiper) {
      try {
        var sw = swiperEl.swiper;
        sw.params.loop = false;
        sw.loopDestroy && sw.loopDestroy();
        sw.update();
      } catch(e) {}
    }

    // --- 3. Eigen video-bullet(s) toevoegen aan de mini-gallery/pagination ---
    var paginationEl = document.querySelector('ul.l4pr .swiper-pagination-clickable');
    var videoBullets = [];
    if (paginationEl) {
      youtubeVideos.forEach(function(video, index) {
        if (paginationEl.querySelector('.has-video-bullet[data-video-index="' + index + '"]')) return;

        var thumbForBullet = (video.thumbs && video.thumbs.medium && video.thumbs.medium.url)
          ? video.thumbs.medium.url
          : (video.thumbs && video.thumbs.high && video.thumbs.high.url
              ? video.thumbs.high.url
              : 'https://img.youtube.com/vi/' + video.providerVideoId + '/mqdefault.jpg');

        var bullet = document.createElement('a');
        bullet.className = 'swiper-pagination-bullet has-video-bullet';
        bullet.setAttribute('tabindex', '0');
        bullet.setAttribute('role', 'navigation');
        bullet.setAttribute('data-video-index', index);

        var slideNode = createdSlides[index];
        var realIndex = slideNode ? Array.prototype.indexOf.call(swiperWrapper.children, slideNode) : -1;
        bullet.setAttribute('data-slide-index', realIndex);

        bullet.style.position = 'relative';

        bullet.innerHTML =
          '<picture><img src="' + thumbForBullet + '" alt="Video" loading="lazy"></picture>' +
          '<span style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:16px;height:16px;background:rgba(0,0,0,0.55);border-radius:50%;display:flex;align-items:center;justify-content:center;pointer-events:none;z-index:5;">' +
            '<svg viewBox="0 0 24 24" fill="white" width="8" height="8"><polygon points="5,3 19,12 5,21"/></svg>' +
          '</span>';

        bullet.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          var details = document.querySelector('.faq-videoly-tab');
          if (details && !details.open) details.open = true;

          var placeholder = document.querySelector('#videoly-videobox-placeholder');
          if (placeholder) scrollNaarMetDuur(placeholder, SCROLL_DUUR_MS);

          setTimeout(function() {
            var vs = document.querySelector('videoly-slider');
            if (vs && vs.tileElements && vs.tileElements[index]) {
              vs.tileElements[index].click();
            }
          }, 600);
        });

        paginationEl.appendChild(bullet);
        videoBullets.push(bullet);
      });
    }

    // --- 4. Paars randje synchroniseren voor de video-bullet bij het swipen ---
    if (swiperEl && swiperEl.swiper && videoBullets.length) {
      swiperEl.swiper.on('slideChange', function() {
        var activeIndex = swiperEl.swiper.activeIndex;
        videoBullets.forEach(function(b) {
          var slideIndex = parseInt(b.getAttribute('data-slide-index'), 10);
          b.classList.toggle('video-bullet-active', activeIndex === slideIndex);
        });
      });
    }

    injected = true;
    observer.disconnect();
  }

  var placeholder = document.querySelector('#videoly-videobox-placeholder');

  if (placeholder) {
    injectVideos();
    var observer = new MutationObserver(function() {
      injectVideos();
    });
    observer.observe(placeholder, { childList: true, subtree: true });
  } else {
    var observer = new MutationObserver(function() {
      var ph = document.querySelector('#videoly-videobox-placeholder');
      if (ph) {
        injectVideos();
        observer.disconnect();
        observer.observe(ph, { childList: true, subtree: true });
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();